import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class JwtHelperServiceWrapper {

    public getJwtHelperService(): JwtHelperService {
        return new JwtHelperService();
    }

}
